import { useQuery, useQueryClient } from 'react-query';

import { apiClient } from 'src/services/api/client';
import { queryKeys } from 'src/services/api/constants';
import type { IListing } from 'src/services/api/listings/types';
import { GET_LEADS_PATH } from 'src/services/api/leads/constants';

type IGetLeadListingsResponse = {
    listings: IListing[];
};

const fetchLeadListings = async (leadUuid?: string): Promise<IListing[]> => {
    if (!leadUuid) {
        throw new Error('Lead UUID is required to fetch lead listings');
    }

    const res = await apiClient(`${GET_LEADS_PATH}/${leadUuid}/listings`).json<IGetLeadListingsResponse>();
    return res.listings;
};

export const getLeadListingsQueryKey = (leadUuid?: string) => [
    queryKeys.leads,
    leadUuid,
    'listings',
];

export const useLeadListings = (leadUuid?: string) => {
    const queryClient = useQueryClient();

    return useQuery<IListing[]>(
        getLeadListingsQueryKey(leadUuid),
        async () => fetchLeadListings(leadUuid),
        {
            enabled: !!leadUuid,
            onSuccess: (listings) => {
                for (const listing of listings) {
                    queryClient.setQueryData([queryKeys.listings, listing.id], listing);
                }
            },
        }
    );
};
